import ts from 'typescript';

import { EvaluateExpressionError } from '../errors';
import type { Evaluator } from '../types';

const evaluateCallExpression: Evaluator<ts.CallExpression> = ({ node, variables, log, evaluators }) => {
  if (ts.isPropertyAccessExpression(node.expression)) {
    const expressionValue = evaluators.expression({
      evaluators,
      log,
      node: node.expression.expression,
      variables,
    });

    if (node.expression.name.escapedText === 'includes') {
      const argument = evaluators.expression({
        evaluators,
        log,
        node: node.arguments[0],
        variables,
      });

      if (argument === null || argument === undefined) {
        return false;
      }

      if (Array.isArray(expressionValue) || typeof expressionValue === 'string') {
        // don't strictly check the type of the accessor, just let javascript try.

        return expressionValue.includes(argument as any);
      }
      return false;
    }

    if (node.expression.name.escapedText === 'toLowerCase') {
      if (typeof expressionValue === 'string') {
        return expressionValue.toLowerCase();
      }

      if (typeof expressionValue === 'number') {
        return String(expressionValue).toLowerCase();
      }

      if (expressionValue === null) {
        return null;
      }

      return undefined;
    }
  }

  log.error(
    new EvaluateExpressionError('Unsupported CallExpression', { kind: node.kind }),
    'evaluate-expression-error',
  );
  log.info({ node, variables }, 'evaluate-expression-error');

  return undefined;
};

export default evaluateCallExpression;
